import React, { useRef, useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { Link as RouterLink, useOutletContext } from 'react-router-dom';
// material
import {
    TextField,
    Card,
    Table,
    Stack,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    TableContainer,
    TablePagination,
    Button, IconButton, TableHead,
    useTheme
} from '@mui/material';
import Scrollbar from '../../components/Scrollbar';
import request from '../../components/request'
import editFill from '@iconify/icons-eva/edit-fill';
import { MoreMenu, Pager } from '../MyComponents';


function Header({ numSelected, submit, loading = false }) {

    const LoginSchema = Yup.object().shape({
        Key: Yup.string()
    });

    const formik = useFormik({
        initialValues: {
            Key: '',
        },
        validationSchema: LoginSchema,
        onSubmit: (values, actions) => {
            //验证
            values = { t: Math.random(), ...values };
            console.log('values', values);
            submit && submit(values).then(result => {

            })
        }
    });

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

    return (
        <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Stack
                    direction={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    p={2}
                    sx={{
                        ...(numSelected > 0 && {
                            color: 'primary.main',
                            bgcolor: 'primary.lighter'
                        })
                    }}
                >
                    {numSelected > 0 ? (
                        <>
                            <Typography component="div" variant="subtitle1">
                                {numSelected} selected
                            </Typography>
                            <IconButton>
                                <Icon icon={'fluent:delete-24-filled'} />
                            </IconButton>
                        </>
                    ) : (
                        <>

                            <Stack direction={'row'}>
                                <TextField
                                    type="text"
                                    label="内容"
                                    {...getFieldProps('Key')}
                                />
                                <Stack flex={1}></Stack>
                            </Stack>

                            <Button
                                disabled={loading}
                                startIcon={<Icon icon={loading ? 'eos-icons:bubble-loading' : 'eva:search-outline'} />}
                                onClick={handleSubmit}
                            >
                                搜索
                            </Button>
                        </>
                    )}
                </Stack>
            </Form>
        </FormikProvider>
    );
}

export default function Index() {
    const [setTools] = useOutletContext();
    const theme = useTheme(); console.log('theme', theme)

    const TABLE_HEAD = [
        { label: '序号', id: 'Num' },
        { label: '预约号', id: 'VisitorOrderNumber' },
        { label: '预约类型', id: 'VisitorOrderType' },
        { label: '人数', id: 'PeopleCount' },
        { label: '时间段', id: 'Time' },
        { label: '业主', id: 'User' },
        { label: '地址', id: 'Address' },
        { label: '创建时间', id: 'UpTime' },
        { label: '操作', id: '', align: 'right' }
    ];

    useEffect(() => {
        setTools([

        ]);
    }, []);

    return (
        <Card>
            <Pager url='/Web/Office/VisitorOrder/VisitorOrderList' pageSize={50}>
                {({ pageData, handleChangePage, searchSubmit, loading }) => {
                    return (
                        <>
                            <Header numSelected={0} submit={searchSubmit} loading={loading} />
                            <Scrollbar>
                                <TableContainer sx={{ minWidth: 800 }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {TABLE_HEAD.map((headCell) => (
                                                    <TableCell align={headCell.align ?? 'inherit'}>
                                                        <div dangerouslySetInnerHTML={{ __html: headCell.label }}></div>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {pageData.data.map((row, index) => {
                                                const { id, VisitorOrderNumber, Pics, Remark, VisitorOrderType, StartTime, EndTime, UpTime, PeopleCount, NickName, Name, Mobile, JiDong, DanYuan, FangHao } = row;
                                                return (
                                                    <TableRow hover>
                                                        <TableCell align="left">{index + 1}</TableCell>
                                                        <TableCell align="left">
                                                            <div>{VisitorOrderNumber}</div>
                                                            <div style={{ display: 'flex' }}>
                                                                {Pics && Pics.length > 0 && (<span style={{
                                                                    border: '0px solid red',
                                                                    backgroundColor: theme.palette.primary.main,
                                                                    color: '#FFF',
                                                                    height: '16px',
                                                                    width: '15px',
                                                                    lineHeight: '15px', marginRight: 4
                                                                }}>图</span>)}
                                                                {Remark && Remark.length > 0 && (<span style={{
                                                                    border: '0px solid red',
                                                                    backgroundColor: theme.palette.primary.main,
                                                                    color: '#FFF',
                                                                    height: '16px',
                                                                    width: '15px',
                                                                    lineHeight: '15px', marginRight: 4
                                                                }}>备</span>)}
                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="left">{VisitorOrderType}</TableCell>
                                                        <TableCell align="left">{PeopleCount}</TableCell>
                                                        <TableCell align="left">
                                                            <div dangerouslySetInnerHTML={{ __html: StartTime + '<br />' + EndTime }}></div>
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <div dangerouslySetInnerHTML={{ __html: (Name && NickName) + '<br />' + Mobile }}></div>
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {JiDong + DanYuan + FangHao}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <div dangerouslySetInnerHTML={{ __html: UpTime.Format('yyyy-MM-dd<br/>hh:mm:ss') }}></div>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <MoreMenu Sub={
                                                                [
                                                                    {
                                                                        label: '查看',
                                                                        icon: <Icon icon={editFill} width={24} height={24} />,
                                                                        to: `/dashboard/visitororder/list/detail/${id}`
                                                                    },
                                                                    {
                                                                        label: '记录',
                                                                        icon: <Icon icon={editFill} width={24} height={24} />,
                                                                        to: `/dashboard/visitororder/inoutlog/${VisitorOrderNumber}`
                                                                    }
                                                                ]
                                                            } />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Scrollbar>

                            <TablePagination
                                rowsPerPageOptions={-1}
                                component="div"
                                count={pageData.totalCount}
                                rowsPerPage={pageData.pageSize}
                                page={pageData.pageIndex}
                                onPageChange={handleChangePage}
                            />
                        </>
                    )
                }}
            </Pager>
        </Card>
    );
}
